mutation DeleteHaftarah($id: ID!) {
  deleteHaftarah(id: $id) {
    ok
    errors
  }
}
